export enum UserConsentsTypeEnum {
    Checkout = 'checkout',
    Invoice = 'invoice',
    Order = 'order',
    OrdersHistory = 'orders-history',
    AutoConfirmPaymentMethod = 'auto-confirm-payment-method',
}
